import { http } from './config'
import authHeader from './auth-header'

export default {
  upload: (nomeCampanha, arquivo) => {
    const formData = new FormData()
    formData.append('nomeCampanha', nomeCampanha)
    formData.append('arquivo', arquivo)
    return http.post('/campanha/upload', formData, {
      headers: {
        ...authHeader(),
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  listarUltimas: () => {
    return http.get('/campanha/imagens', {
      headers: authHeader(),
    })
  },
}
